// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fe37b331","232":"2f0885c8","237":"373ecb29","526":"3c0240e6","787":"96169874","872":"0416191c"}[chunkId] + ".chunk.js";
};